import React, {Component} from "react"

class Alert extends Component {

  render() {
    const spinner = this.props.show?
      <div className={`alert alert-${this.props.level || 'danger'}`}>
        {this.props.message}
      </div> : null
    return spinner
  }
}

export default Alert



// WEBPACK FOOTER //
// ./src/components/Alert.js